import { z } from 'zod';

import { idSchema } from './utils';

export type ProjectDocumentationPathParams = z.infer<typeof projectDocumentationPathParamsSchema>;
export const projectDocumentationPathParamsSchema = z.object({
  projectId: idSchema('projectId'),
  projectDocumentationId: idSchema('projectDocumentationId'),
});
export const projectRoofTypeSchema = z.union([
  z.literal('conventionalCompactRoof'),
  z.literal('invertedCompactRoof'),
  z.literal('duoCompactRoof'),
  z.literal('compactWoodenRoof'),
  z.literal('ventilatedPitchedRoof'),
  z.literal('other'),
]);
export const projectRoofMembraneSchema = z.union([
  z.literal('asphalt'),
  z.literal('foil'),
  z.literal('other'),
]);
export const projectRoofMembraneColorSchema = z.union([z.literal('dark'), z.literal('light')]);
export const projectInsulationTypeSchema = z.union([
  z.literal('flammable'),
  z.literal('nonFlammable'),
  z.literal('mixed'),
]);
export const projectDeckSchema = z.union([
  z.literal('trp'),
  z.literal('concrete'),
  z.literal('wood'),
  z.literal('other'),
]);
export const projectVaporBarrierSchema = z.union([
  z.literal('plastic'),
  z.literal('enforcedMembrane'),
  z.literal('enforcedMembraneAluminium'),
  z.literal('other'),
]);
export const projectUValueSchema = z.number().min(0).max(10000).nullable();
export const projectInsulationThicknessSchema = z.number().min(0).max(10000).nullable();

export type ProjectDocumentation = z.infer<typeof projectDocumentationSchema>;
export const projectDocumentationSchema = z.object({
  projectDocumentationId: z.number().int().nonnegative(),
  projectId: z.number().int().nonnegative(),
  roofType: projectRoofTypeSchema.nullable().optional(),
  roofMembrane: projectRoofMembraneSchema.nullable().optional(),
  roofMembraneColor: projectRoofMembraneColorSchema.nullable().optional(),
  insulationType: projectInsulationTypeSchema.nullable().optional(),
  insulationThickness: projectInsulationThicknessSchema.nullable().optional(),
  uValue: projectUValueSchema.nullable().optional(),
  roofDeck: projectDeckSchema.nullable().optional(),
  roofVaporBarrier: projectVaporBarrierSchema.nullable().optional(),
  isGreenRoof: z.boolean(),
  isBlueRoof: z.boolean(),
  isVacuumRoof: z.boolean(),
  hasSolarPanels: z.boolean(),
  hasTerraceDeck: z.boolean(),
  hasConcreteOverlay: z.boolean(),
  hasConductiveUnderlay: z.boolean(),
  comment: z.string().max(500).nullable().optional(),
  createdAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
  updatedBy: z.number().nullable(),
  updatedByName: z.string().nullable(),
});

export type CreateProjectDocumentationBody = z.infer<typeof createProjectDocumentationBodySchema>;
export const createProjectDocumentationBodySchema = projectDocumentationSchema
  .omit({
    projectDocumentationId: true,
    projectId: true,
    createdAt: true,
    updatedAt: true,
    updatedBy: true,
    updatedByName: true,
  })
  .required({
    roofType: true,
    insulationType: true,
  });

export type UpdateProjectDocumentationBody = z.infer<typeof updateProjectDocumentationBodySchema>;
export const updateProjectDocumentationBodySchema = projectDocumentationSchema.omit({
  projectDocumentationId: true,
  projectId: true,
  createdAt: true,
  updatedAt: true,
  updatedBy: true,
  updatedByName: true,
});
